var React = require('react');

function IconHamburgerInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.977783","y":"0.690918","width":"23.4666","height":"1.96364","key":0}),React.createElement("rect",{"x":"0.977783","y":"10.9358","width":"23.4666","height":"1.96364","key":1}),React.createElement("rect",{"x":"0.977783","y":"21.1812","width":"23.4666","height":"1.96363","key":2})]);
}

IconHamburgerInline.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = IconHamburgerInline;

IconHamburgerInline.default = IconHamburgerInline;
